import { render } from "./AverageModal.vue?vue&type=template&id=41d70ef7&scoped=true"
import script from "./AverageModal.vue?vue&type=script&lang=js"
export * from "./AverageModal.vue?vue&type=script&lang=js"

import "./AverageModal.vue?vue&type=style&index=0&id=41d70ef7&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d70ef7"]])

export default __exports__